import { Card } from "@/components/ui/Card";
import TagsTable from "./components/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import { useParams } from "react-router-dom";

const Tags = () => {
  useDocumentTitle("Business Units");
  const { eventId } = useParams()

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <TagsTable eventId={Number(eventId) || undefined} />
      </Card>
    </div>
  );
};

export default Tags;
